import React from 'react';
export function MobileDownsellBanner() {
  return null;
}